import { useTimer as useTimerLib } from 'react-timer-hook';

import type { TimerSettings } from 'react-timer-hook';

export function useTimer(settings: TimerSettings) {
  return useTimerLib(settings);
}
